import React from "react"
import PropTypes from "prop-types"
import {
  ExternalLink,
  ExternalLinkSizes,
} from "@modules/ui/components/ExternalLink"
import { BuildStatus } from "@modules/graphql/types"
import { useTracker } from "@modules/analytics"

const allowedStatuses = [
  BuildStatus.Success,
  BuildStatus.Publishing,
  BuildStatus.PublishError,
  BuildStatus.PublishCanceled,
]

const propTypes = {
  organizationId: PropTypes.string.isRequired,
  buildStatus: PropTypes.oneOf(Object.values(BuildStatus)).isRequired,
  buildId: PropTypes.string,
  uiSource: PropTypes.string,
  className: PropTypes.string,
}

export default function BuildViewLink({
  organizationId,
  buildStatus,
  buildId,
  uiSource,
  ...rest
}) {
  const { trackButtonClicked } = useTracker()

  if (!allowedStatuses.includes(buildStatus)) {
    return null
  }

  return (
    <ExternalLink
      size={ExternalLinkSizes.S}
      href={`https://build-${buildId}${process.env.GATSBY_PREVIEW_DOMAIN}`}
      onClick={() => {
        trackButtonClicked(`View build`, {
          organizationId,
          uiSource,
          buildId,
        })
      }}
      {...rest}
    />
  )
}

BuildViewLink.propTypes = propTypes
